import { IBillBreakdownLine } from "./billBreakdown.types"

export class BillBreakdownLine implements IBillBreakdownLine {
  id: number
  description: string
  billAmount: number

  constructor(id: number, description: string, billAmount: number) {
    this.id = id
    this.description = description
    this.billAmount = billAmount
  }
}
